export const queryKeys = {
  all: ['lightmap-genius'] as const,
  
  projects: () => [...queryKeys.all, 'projects'] as const,
  project: (id: string) => [...queryKeys.projects(), id] as const,
  
  floorPlans: () => [...queryKeys.all, 'floor-plans'] as const,
  floorPlan: (id: string) => [...queryKeys.floorPlans(), id] as const,
  floorPlanMetadata: (id: string) => [...queryKeys.floorPlan(id), 'metadata'] as const,
  
  entities: (table: string) => [...queryKeys.all, 'entities', table] as const,
  entitiesByFloorPlan: (table: string, floorPlanId: string) => 
    [...queryKeys.entities(table), 'floor-plan', floorPlanId] as const,
  entity: (table: string, id: string) => [...queryKeys.entities(table), id] as const,
  
  // Specific entity queries
  fixtures: (floorPlanId: string) => 
    queryKeys.entitiesByFloorPlan('lighting_fixtures', floorPlanId),
  circuits: (floorPlanId: string) => 
    queryKeys.entitiesByFloorPlan('circuits', floorPlanId),
  controls: (floorPlanId: string) => 
    queryKeys.entitiesByFloorPlan('lighting_controls', floorPlanId),
  rooms: (floorPlanId: string) => 
    queryKeys.entitiesByFloorPlan('rooms', floorPlanId),
  panels: (floorPlanId: string) => 
    queryKeys.entitiesByFloorPlan('panels', floorPlanId),
};
